import { FC } from 'react';
import { UploadedFile } from '@/types/index';

interface PhotoGalleryProps {
  photos: UploadedFile[];
  onSetPrimary: (fileId: string) => Promise<void>;
  onDelete: (fileId: string) => Promise<void>;
  editable?: boolean;
}

export const PhotoGallery: FC<PhotoGalleryProps> = ({
  photos,
  onSetPrimary,
  onDelete,
  editable = true,
}) => {
  const handleSetPrimary = async (fileId: string) => {
    try {
      await onSetPrimary(fileId);
    } catch (error) {
      console.error('Erreur définition photo principale:', error);
      alert('Erreur lors de la définition de la photo principale');
    }
  };

  const handleDelete = async (fileId: string) => {
    if (!confirm('Supprimer cette photo ?')) return;

    try {
      await onDelete(fileId);
    } catch (error) {
      console.error('Erreur suppression photo:', error);
      alert('Erreur lors de la suppression de la photo');
    }
  };

  if (photos.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500 dark:text-gray-400">
        Aucune photo pour cette propriété
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {photos.map((photo) => (
        <div
          key={photo.id}
          className="relative group rounded-lg overflow-hidden border-2 border-gray-200 dark:border-gray-700"
        >
          {/* Image */}
          <img
            src={`${import.meta.env.VITE_API_URL}${photo.url}`}
            alt={photo.originalName}
            className="w-full h-40 object-cover"
          />

          {/* Badge photo principale */}
          {photo.isPrimary && (
            <div className="absolute top-2 left-2 bg-yellow-400 text-yellow-900 px-2 py-1 rounded text-xs font-semibold flex items-center gap-1">
              <span className="text-base">⭐</span> Principale
            </div>
          )}

          {/* Overlay avec actions */}
          {editable && (
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-all duration-200 flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100">
              {!photo.isPrimary && (
                <button
                  onClick={() => handleSetPrimary(photo.id)}
                  className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded-full transition-colors text-lg"
                  title="Définir comme photo principale"
                >
                  ⭐
                </button>
              )}

              <button
                onClick={() => handleDelete(photo.id)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-full transition-colors text-lg"
                title="Supprimer"
              >
                🗑️
              </button>
            </div>
          )}

          {/* Nom du fichier */}
          <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white text-xs p-2 truncate">
            {photo.originalName}
          </div>
        </div>
      ))}
    </div>
  );
};
